module.exports = __webpack_public_path__ + "static/img/bg.389fbb9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wpd/bg.svg
// module id = yazV
// module chunks = 1